export const translations = {
  id: {
    // Personal Info
    contact: 'Kontak',
    email: 'Email',
    phone: 'Telepon',
    location: 'Lokasi',
    address: 'Alamat',
    
    // Sections
    profile: 'Profil',
    summary: 'Ringkasan',
    professionalSummary: 'Ringkasan Profesional',
    careerObjective: 'Objektif Karir',
    about: 'Tentang Saya',
    skills: 'Keahlian',
    coreCompetencies: 'Kompetensi Inti',
    experience: 'Pengalaman Kerja',
    workExperience: 'Pengalaman Kerja',
    professionalExperience: 'Pengalaman Profesional',
    education: 'Pendidikan',
    higherEducation: 'Pendidikan Tinggi',
    formalEducation: 'Pendidikan Formal',
    projects: 'Proyek',
    keyProjects: 'Proyek Unggulan',
    
    // Additional
    description: 'Deskripsi',
    technologies: 'Teknologi',
    role: 'Peran',
    duration: 'Durasi',
    present: 'Sekarang',
    
    // Defaults
    noDescription: 'Tidak ada deskripsi',
    noProjects: 'Belum ada proyek',
  },
  en: {
    // Personal Info
    contact: 'Contact',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
    address: 'Address',
    
    // Sections
    profile: 'Profile',
    summary: 'Summary',
    professionalSummary: 'Professional Summary',
    careerObjective: 'Career Objective',
    about: 'About Me',
    skills: 'Skills',
    coreCompetencies: 'Core Competencies',
    experience: 'Experience',
    workExperience: 'Work Experience',
    professionalExperience: 'Professional Experience',
    education: 'Education',
    higherEducation: 'Higher Education',
    formalEducation: 'Formal Education',
    projects: 'Projects',
    keyProjects: 'Key Projects',
    
    // Additional
    description: 'Description',
    technologies: 'Technologies',
    role: 'Role',
    duration: 'Duration',
    present: 'Present',
    
    // Defaults
    noDescription: 'No description available',
    noProjects: 'No projects yet',
  }
};

export const t = (key, language = 'id') => {
  return translations[language]?.[key] || translations['id'][key] || key;
};
